import Swiper, {Navigation, Lazy} from "swiper";
import Choices from "choices.js";
import PerfectScrollbar from "perfect-scrollbar";

import axios from "@main/axios";
import {MD_WIDTH, LG_WIDTH} from "@main/helpers/const";
import {logger} from "@main/helpers/logger";
import {getSiblings} from "@main/helpers/dom";
import {Calendar} from "@main/components/datepicker";

import {getAndUpdatePublication} from "./get-filter-publications";

const NUMBER_OF_SLIDES_TO_END = 2;
const TIMEOUT_FOR_SCROLLBAR_INIT = 2000;
const MAX_VISIBLE_NUM_IN_PAGINATION = 5;
const START_INDEX_YEAR = 0;
const END_INDEX_YEAR = 4;

class FilterPublicationsSlider {
    swiper

    selectedYear
    
    selectedMonth

    mobileListMonths = []

    mobileSelectMonths

    mobileSelectYears

    year

    month

    day

    publicationsDates

    datesPublicationsPosted = []

    page = 1

    pageCount

    pagination = null

    yearsList = []

    constructor(el) {
        this.el = el;
        this.swiperWrap = this.el.querySelector(".swiper-wrapper");
        this.url = this.el.dataset.url;
        this.datesUrl = this.el.dataset.datesUrl;
        this.size = this.el.querySelector(".js-publications").dataset.size;
        this.datepicker = this.el.querySelector(".js-datepicker");
        this.autoWidth = document.body.classList.contains("special_version");

        if (this.el.nextElementSibling.classList.contains("js-pagination")) {
            this.pagination = this.el.nextElementSibling;
            this.pageCount = this.el.querySelector(".js-publications").dataset.initPages;
        }
        
        this.bindEventListeners();
    }

    onMounted = async () => {  
        // получаем список дат, в которые выложены объявления
        this.publicationsDates = await this.getPublicationsDates();

        // массив дат для вывода в календаре
        this.publicationsDates.data.publicationsDates.forEach(el => {
            this.datesPublicationsPosted.push(el.DATETIME);            
        });
        
        // создаем календарь
        this.createCalendar();

        // формируем список годов
        this.createYearsList();

        // создаем селекты
        this.createSelectYearsPublication();        
        this.createSelectMonthsPublication();
        
        // инициализируем слайдер
        if (this.el.querySelector(".js-filter-publications-slider")) {
            this.enableSlider();

            this.page = +this.swiper.el.getAttribute("data-page");
        }

        // создаем пагинацию
        this.createPagination();
    }

    bindEventListeners() {
        document.addEventListener("maponload", this.onMounted);
        document.addEventListener("click", e => {
            // Клик по ссылке еще...
            if (e.target.classList.contains("js-publication-month-more")) {
                this.openMonthSublist(e.target);
            }

            // Выбор месяца на экранах tablet + 
            if (e.target.classList.contains("js-publication-month-item")) {
                this.onClickMonthOnDesktop(e.target);
            }

            // Закрытие списка месяцев по клику вне его
            if (!e.target.classList.contains("js-publication-month-more") 
                && !e.target.closest(".js-publication-month-more")) {
                this.closeMonthSublist();
            }
        });
        
        this.updatePageNumber();
    }

    // получаем активные даты для календаря 
    getPublicationsDates = async () => {
        try {
            const {data} = await axios({
                url: this.datesUrl,
                method: "GET",
            });

            return data;
        } catch (e) {
            logger.log(e);
        }
    }    

    // формируем список годов
    createYearsList() {
        const years = this.datesPublicationsPosted.map(item => item.slice(START_INDEX_YEAR, END_INDEX_YEAR));
        const uniqueYears = [...new Set(years)];
        uniqueYears.forEach(el => {
            let yearOption = {
                value: el,
                label: el,
            }

            this.yearsList.push(yearOption);
        })
    }

    // создаем выпадающий список месяцев на телефоне
    createChoicesMonthsOnMobile(monthsData) { 
        if (!monthsData) {
            return
        }

        monthsData.forEach(month => { 
            const selectItem = {
                value: month.MONTH_ID,      
                label: month.MONTH.slice(0, 3),             
            }
            this.mobileListMonths.push(selectItem);
        })
    }

    // создаем список месяцев на десктопе
    createMonthListOnDesktop(monthsData) {
        if (!monthsData) {
            return
        }

        const monthLength = monthsData.length;
        const monthList = document.querySelector(".js-publication-month-list");
        const firstThreeMonths = monthsData.slice(0, 3);
        const otherMonths = monthsData.slice(3);

        monthList.innerHTML = "";

        firstThreeMonths.forEach(month => {
            const li = document.createElement("li");
            li.className = "list-month__item js-publication-month-item";
            li.innerHTML = month.MONTH;
            li.setAttribute("data-month", month.MONTH_ID);
            monthList.insertAdjacentElement("beforeend", li);
        });

        if (monthLength > 3) {
            const liLinkMore = document.createElement("li");
            liLinkMore.className = "list-month__item list-month__link-more js-publication-month-more";
            liLinkMore.innerHTML = "Еще...";
            monthList.insertAdjacentElement("beforeend", liLinkMore);

            const ul = document.createElement("ul");
            ul.className = "list-month__sublist sublist hidden js-publication-month-sublist js-scrollbar";
            liLinkMore.insertAdjacentElement("beforeend", ul);

            otherMonths.forEach(month => {
                const li = document.createElement("li");
                li.className = "list-month__subitem sublist__item js-publication-month-item";
                li.innerHTML = month.MONTH;
                li.setAttribute("data-month", month.MONTH_ID);
                ul.insertAdjacentElement("beforeend", li);
            });

            // создаем скроллбар для выпадающего списка месяцев
            const publicationMonthSublist = document.getElementsByClassName("js-publication-month-sublist");

            setTimeout(() => {
                if (publicationMonthSublist) {
                    let sublist = Array.from(publicationMonthSublist);
                    sublist.forEach(el => {        
                        new PerfectScrollbar(el);
                    })
                }  
            }, TIMEOUT_FOR_SCROLLBAR_INIT);
        } 
    }

    // открываем выпадающий список на десктопе, если месяцев больше трех
    openMonthSublist(target) {
        const sublists = Array.from(target.children);
        sublists.forEach(el => {
            el.classList.remove("hidden");
        })
    }

    // закрываем выпадающий список на десктопе
    closeMonthSublist() {
        const containerSublist = document.querySelector(".js-publication-month-more");

        if (!containerSublist) {
            return;
        }

        const sublist = containerSublist.querySelector(".js-publication-month-sublist");
        if (!sublist.classList.contains("hidden")) {
            sublist.classList.add("hidden");
        }
    }

    // Устанавливаем активный месяц
    setActiveMonth(target) {
        // Присваиваем активный класс выбранному месяцу
        if (!target.classList.contains("is-active")) {
            target.classList.add("is-active");
        }        

        // Присваиваем активный класс выбранному месяцу внутри выпадающего списка
        if (target.parentElement.classList.contains("js-publication-month-sublist")) {
            target.parentElement.classList.add("hidden");
            target.closest(".js-publication-month-more").classList.add("is-active");
            
            const siblings = getSiblings(target.closest(".js-publication-month-more"));
            siblings.forEach(el => {
                if (el.classList.contains("is-active")) {
                    el.classList.remove("is-active");
                }
            })
        }
        
        // Удалить активный класс у соседних элементов
        const siblings = getSiblings(target);
        siblings.forEach(el => {
            if (el.classList.contains("is-active")) {
                el.classList.remove("is-active");
            }
        })

        // Удалить активный класс внутри выпадающего списка, если активен пункт вне этого списка
        const containerSublist = document.querySelector(".js-publication-month-more");
        
        if (containerSublist) {
            const sublist = containerSublist.querySelector(".js-publication-month-sublist");
            const subitems = sublist.querySelectorAll(".js-publication-month-item");
        
            subitems.forEach(item => {
                if (!containerSublist.classList.contains("is-active")) {
                    item.classList.remove("is-active");
                }
            })
        }
    }

    // действия при клике на месяц на десктопе
    onClickMonthOnDesktop = async (target) => {
        this.setActiveMonth(target);

        // Получаем выбранный месяц и делаем запрос
        this.selectedMonth = target.dataset.month;
        this.month = this.selectedMonth;
        this.year = this.selectedYear;
        this.page = 1;  
        
        if (this.swiper?.el?.hasAttribute("data-slider")) {
            this.swiper.el.removeAttribute("data-slider");
        }
        
        const response = await getAndUpdatePublication(this.el, this.swiper, this.url, this.size, 
            this.year, this.month, this.day = undefined, this.page);

        this.pageCount = response.pageCount; 
        this.swiper?.el.setAttribute("data-page", this.pageCount); 

        if (this.pagination) {            
            this.goToPage(this.page, this.pageCount);
        }
    }

    // создаем слайдер
    enableSlider() {
        document.querySelectorAll(".js-filter-publications-slider").forEach(slider => {
            let slidesPerView = 3;
            if (this.autoWidth) {
                slidesPerView = "auto";
            }
            this.swiper = new Swiper(slider, {
                modules: [Navigation, Lazy],
                slidesPerView: "auto",
                preloadImages: false,
                watchSlidesProgress: true,
                spaceBetween: 8,
                followFinger: false,
                observer: true,
                observeParents: true,
                createElements: true,
                breakpoints: {
                    [MD_WIDTH]: {
                        spaceBetween: 16,
                    },
                    [LG_WIDTH]: {
                        slidesPerView: slidesPerView,
                        spaceBetween: 16,
                    }
                },
                navigation: {
                    nextEl: ".js-filter-publications-next",
                    prevEl: ".js-filter-publications-prev"
                },
                on: {
                    slideChange: async () => {
                        const length = this.swiper.slides.length;
                        const dataPage = this.swiper.el.dataset.page;
                        if (dataPage == 1) {
                            this.swiper.el.setAttribute("data-slider", "end");
                            return;
                        }

                        if (this.swiper.visibleSlidesIndexes.includes(length - NUMBER_OF_SLIDES_TO_END) 
                            && dataPage != this.page) {
                            this.year = this.selectedYear;
                            this.month = this.selectedMonth ? this.selectedMonth : undefined;

                            this.page += 1;
                            const response = await getAndUpdatePublication(this.el, this.swiper, this.url, this.size, 
                                this.year, this.month, this.day = undefined, this.page);

                            if (response) {
                                this.pageCount = response.pageCount;
                            }

                            if (this.page === this.pageCount) {
                                this.swiper.el.setAttribute("data-slider", "end");
                            }
                        }
                    },
                    update: () => {
                        if (this.swiper.el.hasAttribute("data-slider")) {
                            this.swiper.el.removeAttribute("data-slider");
                        }
                    },
                },
            });
        })
    }

    // обновить список месяцев при изменении года
    updateMonthListOnMobile(monthsData) {
        this.mobileListMonths = [];
        this.mobileSelectMonths.clearChoices();
        this.createChoicesMonthsOnMobile(monthsData);
        this.mobileSelectMonths.setChoices(this.mobileListMonths);
        this.selectedMonth = undefined;
        this.month = undefined;
    }

    // создаем селект с годами
    createSelectYearsPublication() {
        this.selectedYear = this.yearsList[0].value;

        document.querySelectorAll(".js-publication-year-choices").forEach((selectYear) => {
            this.mobileSelectYears = new Choices(selectYear, {
                placeholderValue: this.selectedYear,
                choices: this.yearsList,
                searchEnabled: false,
                searchChoices: false,
                position: "bottom",
                shouldSort: false, 
                itemSelectText: "",
                noResultsText: "Не найдено",
            });

            this.mobileSelectYears.passedElement.element.addEventListener("choice", async (event) => {
                this.selectedYear = event.detail.choice.value; 
                this.year = this.selectedYear;
                this.page = 1;
                this.month = undefined;
                this.selectedMonth = undefined;

                if (this.swiper?.el?.hasAttribute("data-slider")) {
                    this.swiper.el.removeAttribute("data-slider");
                }

                const response = await getAndUpdatePublication(
                    this.el, this.swiper, this.url, this.size, this.year, 
                    this.month = undefined, this.day = undefined, this.page
                );   

                const monthsResponse = response.months;
                this.pageCount = response.pageCount;
                this.swiper?.el.setAttribute("data-page", this.pageCount);  

                if (window.innerWidth < MD_WIDTH) {
                    this.updateMonthListOnMobile(monthsResponse);
                } else {
                    document.querySelector(".js-publication-month-list").innerHTML = "";
                    this.createMonthListOnDesktop(monthsResponse);
                }         

                if (this.pagination) {
                    this.page = 1;

                    this.pagination.innerHTML = "";
                    this.createPagination();
                }
            },
            false,
            );    
        })
    } 

    // создаем селект с месяцами на телефоне
    createSelectMonthsPublication() {    
        document.querySelectorAll(".js-publication-month-choices").forEach(selectMonths => {
            this.mobileSelectMonths = new Choices(selectMonths, {
                placeholderValue: this.choiceMonth,
                searchEnabled: false,
                searchChoices: false,
                position: "bottom",
                shouldSort: false, 
                itemSelectText: "",
                noResultsText: "Не найдено",
            }); 

            this.mobileSelectMonths.passedElement.element.addEventListener("choice", async (event) => {
                this.year = this.selectedYear;
                this.selectedMonth = event.detail.choice.value;
                this.month = this.selectedMonth;
                this.page = 1;  

                if (this.swiper && this.swiper.el.hasAttribute("data-slider")) {
                    this.swiper.el.removeAttribute("data-slider");
                }
                
                const response = await getAndUpdatePublication(this.el, this.swiper, this.url, this.size,
                    this.year, this.month, this.day = undefined, this.page);

                this.pageCount = response.pageCount;
                this.swiper?.el.setAttribute("data-page", this.pageCount);  
                
                if (this.pagination) {
                    this.goToPage(this.page, this.pageCount);
                }
            },
            false,
            );    
        })
    }

    // при отрисовке ячеек календаря
    onRenderCellCalendar = (date, cellType, datepicker) => {
        datepicker.$el.value = "Календарь";

        let day = date.getDate();
        if (day < 10) day = "0" + day;

        let month = date.getMonth() + 1;
        if (month < 10) month = "0" + month;

        let year = date.getFullYear();
        
        const formatDate = year + "-" + month + "-" + day;

        if (cellType === "day") {
            return {
                disabled: !this.datesPublicationsPosted.includes(formatDate)
            }
        }
    }

    // выбор даты в календаре
    onSelectDateCalendar = async (date, formattedDate, datepicker) => {
        datepicker.$el.value = "Календарь";

        this.year = date?.getFullYear().toString();
        this.day = date?.getDate().toString();
        this.month = date?.getMonth() + 1;
        this.selectedMonth = this.month;

        this.mobileSelectYears.setChoiceByValue(this.year);
        this.selectedYear = this.year;
        this.page = 1;

        if (this.swiper?.el?.hasAttribute("data-slider")) {
            this.swiper.el.removeAttribute("data-slider");
        }

        const response = await getAndUpdatePublication(this.el, this.swiper, this.url, this.size, this.year, 
            this.month, this.day, this.page);

        const monthsResponse = response.months;
        this.pageCount = response.pageCount;
        this.swiper?.el.setAttribute("data-page", this.pageCount);  

        if (window.innerWidth < MD_WIDTH) {
            this.mobileListMonths = [];
            this.mobileSelectMonths.clearChoices();
            this.createChoicesMonthsOnMobile(monthsResponse);
            this.mobileSelectMonths.setChoices(this.mobileListMonths);
            const valueMonthString = String(this.month);
            this.mobileSelectMonths.setChoiceByValue(valueMonthString);
        } else {
            document.querySelector(".js-publication-month-list").innerHTML = "";
            this.createMonthListOnDesktop(monthsResponse);

            // установить активный месяц в списке
            const monthList = document.querySelector(".js-publication-month-list");
            const monthItem = monthList.querySelector(`.js-publication-month-item[data-month="${this.month}"]`);
            
            if (monthItem) {
                this.setActiveMonth(monthItem);
            }
        }
        
        if (this.pagination) {
            this.goToPage(this.page, this.pageCount);
        }
    }

    // создание календаря
    createCalendar() {
        new Calendar(this.datepicker, this.onRenderCellCalendar, this.onSelectDateCalendar);
    } 

    // создание пагинации
    createPagination = async () => {
        if (!this.pagination) {
            return;
        }

        for (let i = 1; i <= MAX_VISIBLE_NUM_IN_PAGINATION; i++) {
            const paginationLink = document.createElement("a");
            paginationLink.className = "pagination__link js-pagination-link";
            paginationLink.innerHTML = i;
            paginationLink.setAttribute("data-page", i);

            if (i < MAX_VISIBLE_NUM_IN_PAGINATION + 1) {
                this.pagination.insertAdjacentElement("beforeend", paginationLink);
            }            
        }

        // Добавляем кнопку "В начало"
        const buttonGoToStart = document.createElement("a");
        buttonGoToStart.className = "pagination__link pagination__link--nav js-pagination-first";
        buttonGoToStart.innerHTML = "в начало";
        this.pagination.insertAdjacentElement("afterbegin", buttonGoToStart);

        if (this.page == 1) {
            buttonGoToStart.setAttribute("disabled", "disabled");
            buttonGoToStart.nextElementSibling.classList.add("pagination__link--active");
        } 

        // добавляем кнопку "Дальше"
        const buttonMoveOn = document.createElement("a");
        buttonMoveOn.className = "pagination__link pagination__link--nav js-pagination-farther";
        buttonMoveOn.innerHTML = "дальше";
        this.pagination.insertAdjacentElement("beforeend", buttonMoveOn);

        if (this.pageCount == 1) {
            this.pagination.classList.add("hidden");
        } else if (this.pageCount !== 1 && this.pagination.classList.contains("hidden")) {
            this.pagination.classList.remove("hidden");
        }

        if (this.pageCount > MAX_VISIBLE_NUM_IN_PAGINATION || this.pageCount < MAX_VISIBLE_NUM_IN_PAGINATION) {
            this.updatePagination(this.page, this.pageCount);
        }
    }

    setMonthUndefinedOnDesktop() {
        const monthList = document.querySelector(".js-publication-month-list");
        const activeMonth = monthList.querySelector(".is-active");

        if (!activeMonth && window.innerWidth >= MD_WIDTH) {
            this.month = undefined;
        }
    }

    // клик на "Дальше"
    clickToNextPage(target, numberOfPages) {
        this.page += 1;
        this.year = this.selectedYear;
        this.month = this.selectedMonth;

        this.setMonthUndefinedOnDesktop();

        if (this.page <= numberOfPages) {
            this.goToPage(this.page, numberOfPages);
            getAndUpdatePublication(this.el, this.swiper, this.url, this.size, this.year, this.month,
                this.day, this.page);
        } else {
            target.setAttribute("disabled", "disabled");
        }
    }

    // клик на кнопку "В начало"
    clickButtonToStartPage(numberOfPages) {
        this.page = 1;
        this.year = this.selectedYear;
        this.month = this.selectedMonth;

        this.setMonthUndefinedOnDesktop();

        this.goToPage(this.page, numberOfPages);
        getAndUpdatePublication(this.el, this.swiper, this.url, this.size, this.year, this.month, 
            this.day, this.page);
    }

    // обновить номер страницы
    updatePageNumber() {
        if (!this.pagination) {
            return;
        }

        this.pagination.addEventListener("click", async (e) => {
            const target = e.target;
            e.preventDefault();

            // клик на номер страницы
            if (target.classList.contains("js-pagination-link")) {                
                // получаем номер страницы
                const numberPage = Number(target.getAttribute("data-page"));

                this.page = numberPage;
                this.year = this.selectedYear;
                this.month = this.selectedMonth;

                this.setMonthUndefinedOnDesktop();

                this.goToPage(this.page, this.pageCount);

                getAndUpdatePublication(this.el, this.swiper, this.url, this.size, this.year, this.month, 
                    this.day, this.page);
 
                this.scrollToTopPaginationList();
            }

            // клик на "Далее"
            if (target.classList.contains("js-pagination-farther")) {
                this.clickToNextPage(target, this.pageCount);
                this.scrollToTopPaginationList();
            }

            // клик на "В начало"
            if (target.classList.contains("js-pagination-first")) {
                this.clickButtonToStartPage(this.pageCount);
                this.scrollToTopPaginationList();
            }
        })
    }

    /**
     * Прокрутить к началу списка с публикациями при переходе на страницу. 
     * 
     * @returns {void}
     */
    scrollToTopPaginationList() {
        const publicationList = this.pagination.previousElementSibling;
        const rectTop = publicationList.getBoundingClientRect().top + window.pageYOffset; 
        window.scrollTo({
            top: rectTop,
            behavior: "smooth"
        });
    }

    // перейти к странице
    goToPage(number, numberOfPages) {
        if (!this.pagination) {
            return;
        }

        this.page = number;

        const paginationLinks = [...this.pagination.getElementsByClassName("js-pagination-link")];

        // Переключать disabled у кнопки "В начало"
        const buttonGoToStart = this.pagination.getElementsByClassName("js-pagination-first");

        if (this.page !== 1 && buttonGoToStart[0].hasAttribute("disabled")) {
            buttonGoToStart[0].removeAttribute("disabled");
        } else if (this.page == 1) {
            buttonGoToStart[0].setAttribute("disabled", "disabled");
        }

        // Переключать disabled у кнопки "Далее"
        const buttonGoToNext = this.pagination.getElementsByClassName("js-pagination-farther");

        if (this.page < numberOfPages && buttonGoToNext[0].hasAttribute("disabled")) {
            buttonGoToNext[0].removeAttribute("disabled");
        } else if (this.page == numberOfPages) {
            buttonGoToNext[0].setAttribute("disabled", "disabled");
        }

        this.updatePagination(this.page, numberOfPages);

        const selectedPage = paginationLinks.filter( (item) => {              
            return +(item.getAttribute("data-page")) === this.page;
        })

        selectedPage.forEach(page => {
            if (!page.classList.contains("pagination__link--active")) {
                page.classList.add("pagination__link--active");

                const siblings = getSiblings(page);
                siblings.forEach(el => {
                    if (el.classList.contains("pagination__link--active")) {
                        el.classList.remove("pagination__link--active");
                    }
                })
            }
        })
    }

    // обновить пагинацию
    updatePagination(currentPage, maxAmount) {
        if (maxAmount == 1) {
            this.pagination.classList.add("hidden");
            return;
        } 

        if (this.pagination.classList.contains("hidden")) {
            this.pagination.classList.remove("hidden");
        }
        
        const paginationLinks = [...this.pagination.querySelectorAll(".js-pagination-link")];
        let newFirstNumberPages;

        if (maxAmount <= MAX_VISIBLE_NUM_IN_PAGINATION) {
            paginationLinks.forEach((link) => { 
                if (link.dataset.page > maxAmount) {
                    link.classList.add("hidden");
                } else {
                    link.classList.remove("hidden");
                }         
            });

            return;
        }

        if (currentPage > Math.ceil(MAX_VISIBLE_NUM_IN_PAGINATION / 2) && 
            currentPage < (maxAmount - Math.floor(MAX_VISIBLE_NUM_IN_PAGINATION / 2))) {            
            newFirstNumberPages = currentPage - Math.floor(MAX_VISIBLE_NUM_IN_PAGINATION / 2);
        }

        if (currentPage <= Math.ceil(MAX_VISIBLE_NUM_IN_PAGINATION / 2)) {
            newFirstNumberPages = 1;
        }

        if (currentPage >= (maxAmount - Math.floor(MAX_VISIBLE_NUM_IN_PAGINATION / 2))) {
            newFirstNumberPages = maxAmount - MAX_VISIBLE_NUM_IN_PAGINATION + 1;
        }
        
        paginationLinks.forEach((link) => {
            if (link.classList.contains("hidden")) {
                link.classList.remove("hidden")
            }
            link.innerHTML = newFirstNumberPages;
            link.setAttribute("data-page", newFirstNumberPages);
            newFirstNumberPages++;            
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".js-filter-publications").forEach(elem => new FilterPublicationsSlider(elem));
});
